module.exports = __webpack_public_path__ + "img/logo-grupo-verfrut.a7a30dd3.png";